import { DecorationDto } from './decoration-dto';

export class InMoldLabelDto extends DecorationDto { }
